<template>
  <div id="area-view" class="area-view">
    <van-popup v-model="show" :close-on-click-overlay="false" position="bottom" :style="{height:'300px' }" >
      <van-area :area-list="areaList" :columns-num="4" title="所在地" @change="changeClick" @cancel="cancelClick" @confirm="confirmClick" />
    </van-popup>
  </div>
</template>

<script>
import areaList from '../components/city/area'
export default {
  name: 'area-view',
  props: {
    show: false
  },
  data () {
    return {
      // show: true,
      areaList: areaList,
      province: '北京市', // 省
      city: '北京市', // 市
      area: '东城区', // 县
      code: '110101' // 县级代码
    }
  },
  methods: {
    changeClick: function (picker, value, index) {
      // console.log(value)
      this.province = value[0]['name']
      this.city = value[1]['name']
      this.area = value[2]['name']
      this.code = value[2]['code']
    },
    confirmClick: function () {
      console.log('确认===============' + this.province + this.city + this.area + this.code)
      this.$emit('selectedArea', this.province, this.city, this.area, this.code)
    },
    cancelClick: function () {
      // console.log('取消===============')
      this.$emit('selectedArea', '', '', '', 0)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/area-view.vue